export default "__VITE_ASSET__0eBLGTZ7__"